module.exports = __webpack_public_path__ + "static/sudamerica-14933c1eaa320821860e246c9b3c573c.png";